import { render, staticRenderFns } from "./viewCompletework.vue?vue&type=template&id=d4699b74&scoped=true"
import script from "./viewCompletework.vue?vue&type=script&lang=js"
export * from "./viewCompletework.vue?vue&type=script&lang=js"
import style0 from "./viewCompletework.vue?vue&type=style&index=0&id=d4699b74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4699b74",
  null
  
)

export default component.exports